<div class="signature-pad" [class.remove]="generate">
    <canvas #signaturePad [height]="parentHeight" [width]="parentWidth"></canvas>
    <!-- <button (click)="clear()">Clear</button> -->
</div>
<!-- <div class="mt-3">
    <button (click)="clear()" class="btn btn-sm btn-secondary mt-2" type="button">Clear
        Signature</button>
</div> -->
